getUserConfirmation